module.exports = __webpack_public_path__ + "img/unread-notif.9503655f.svg";